// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://kzlwjpdjisjirmiqeoic.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt6bHdqcGRqaXNqaXJtaXFlb2ljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc4MTUyODYsImV4cCI6MjA1MzM5MTI4Nn0.6bM_Bo8zdSjPgra8pz4i21FNP9W-m6p1ePiAzSANecg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});